<template>
    <router-link :to="{name: 'login',}" id="app" tag="div">
        <div class="img">
            <img src="../assets/images/logo.png">
        </div>
    </router-link>
</template>

<script>

    export default {
        data(){
          return {
              interval: 0
          }
        },
        created(){
           this.interval=setTimeout(() => this.$router.push({path: '/login'}), 3000)
        },
        destroyed(){
            clearInterval(this.interval);
        }
    }
</script>

<style lang="scss" scoped>
    @import '../assets/css/style';
    #app {
        display: table;
        width: 100%;
        height: 100vh;
        background-color: $lila;
        display: table;

        .img {
            display: table-cell;
            text-align: center;
            vertical-align: middle;
            img{
                width:auto;
            }
        }
    }


</style>



// WEBPACK FOOTER //
// src/components/Home.vue